import { EvaluationStatus, KnowledgeBaseStatus } from "../Enums/companyStatus";
import color from "../Constants/colors";

export const getEvaluationStatusText = (status: EvaluationStatus): string => {
  switch (status) {
    case EvaluationStatus.EVALUATED:
      return "Evaluated";
    case EvaluationStatus.NEEDS_MORE_INFO:
      return "Needs more information";
    case EvaluationStatus.EVALUATION_IN_PROGRESS:
      return "Evaluation in progress";
    case EvaluationStatus.ERROR:
      return "Error";
    case EvaluationStatus.GATHERING_DIGITAL_PERFORMANCE:
      return "Gathering digital performance";
    case EvaluationStatus.FETCHING_COMPANY_DETAILS:
      return "Fetching company details";
    case EvaluationStatus.PROCESSING_COMPANY_INFORMATIONS:
      return "Processing company information";
    case EvaluationStatus.GRADING_COMPANY:
      return "Grading entity";
    case EvaluationStatus.TIME_LIMIT_EXCEEDED:
      return "Time limit exceeded";
    case EvaluationStatus.INITIALIZED:
      return "Initialized";
    case EvaluationStatus.PAUSED:
      return "Paused";
    default:
      return "Unknown status";
  }
};

export const getStatusBackgroundColor = (status: EvaluationStatus): string => {
  switch (status) {
    case EvaluationStatus.EVALUATED:
      return color.green;
    case EvaluationStatus.NEEDS_MORE_INFO:
      return color.accent;
    case EvaluationStatus.ERROR:
    case EvaluationStatus.TIME_LIMIT_EXCEEDED:
      return color.red;
    case EvaluationStatus.PAUSED:
      return color.accent;
    case EvaluationStatus.EVALUATION_IN_PROGRESS:
    case EvaluationStatus.GATHERING_DIGITAL_PERFORMANCE:
    case EvaluationStatus.FETCHING_COMPANY_DETAILS:
    case EvaluationStatus.PROCESSING_COMPANY_INFORMATIONS:
    case EvaluationStatus.GRADING_COMPANY:
    case EvaluationStatus.INITIALIZED:
      return color.accent;
    default:
      return color.secondaryDark;
  }
};

export const getStatusTextColor = (status: KnowledgeBaseStatus): string => {
  switch (status) {
    case KnowledgeBaseStatus.WAITING:
      return color.yellow;
    case KnowledgeBaseStatus.IN_PROGRESS:
      return color.accent;
    case KnowledgeBaseStatus.PROCESSED:
      return color.green;
    case KnowledgeBaseStatus.ERROR:
      return color.red;
    case KnowledgeBaseStatus.TIME_LIMIT_EXCEEDED:
      return color.primary_medium;
    case KnowledgeBaseStatus.STOPPED:
      return color.primary_dark;
    default:
      return "transparent";
  }
};
